import {
    CREATE_PRODUCT_MASTER_REQUEST,
    CREATE_PRODUCT_MASTER_SUCCESS,
    CREATE_PRODUCT_MASTER_FAILURE,
    DELETE_PRODUCT_MASTER_REQUEST,
    DELETE_PRODUCT_MASTER_SUCCESS,
    DELETE_PRODUCT_MASTER_FAILURE,
    FETCH_SINGLE_PRODUCT_MASTER_REQUEST,
    FETCH_SINGLE_PRODUCT_MASTER_SUCCESS,
    FETCH_SINGLE_PRODUCT_MASTER_FAILURE,
    FETCH_PRODUCT_MASTER_REQUEST,
    FETCH_PRODUCT_MASTER_SUCCESS,
    FETCH_PRODUCT_MASTER_FAILURE,
    UPDATE_PRODUCT_MASTER_REQUEST,
    UPDATE_PRODUCT_MASTER_SUCCESS,
    UPDATE_PRODUCT_MASTER_FAILURE,
    RESET_PRODUCT_MASTER_INFO,
    CREATE_PRODUCT_MASTER_FORM,
    UPDATE_PRODUCT_MASTER_FORM,
    NAVIGATE_PRODUCT_MASTER,
    FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS,
    NAVIGATE_PRODUCT_DETAILS
} from './product.actionsType';

export const PRODUCT_MASTER = 'productMaster';

let initialState = {
    loading: false,
    productMaster: [],
    productMasterform: {},
    selectedState: {},
    productCategory: [],
    productItem: [],
    errorMessage: '',
    productId: {},
    isPartyDetails: false
};

export let productMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCT_MASTER_REQUEST:
        case CREATE_PRODUCT_MASTER_REQUEST:
        case UPDATE_PRODUCT_MASTER_REQUEST:
        case FETCH_SINGLE_PRODUCT_MASTER_REQUEST:
        case DELETE_PRODUCT_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                productMaster: updatePayload
            };
        case FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS:
            if (payload == 9) {
                return {
                    ...state,
                    loading: false,
                    productItem: updatePayload
                };
            } else if (payload == 10) {
                return {
                    ...state,
                    loading: false,
                    productCategory: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_PRODUCT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                productMasterform: {}
            };
        case UPDATE_PRODUCT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                productMasterform: {}
            };
        case FETCH_SINGLE_PRODUCT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                productMasterform: updatePayload
            };
        case DELETE_PRODUCT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                productMasterform: {}
            };
        case RESET_PRODUCT_MASTER_INFO:
            return {
                ...state,
                productMasterform: {}
            };
        case CREATE_PRODUCT_MASTER_FORM:
        case UPDATE_PRODUCT_MASTER_FORM:
            return {
                ...state,
                loading: false,
                productMasterform: {
                    ...state.productMasterform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PRODUCT_MASTER_FAILURE:
        case CREATE_PRODUCT_MASTER_FAILURE:
        case UPDATE_PRODUCT_MASTER_FAILURE:
        case FETCH_SINGLE_PRODUCT_MASTER_FAILURE:
        case DELETE_PRODUCT_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            };
        case NAVIGATE_PRODUCT_DETAILS:
            return {
                ...state,
                isPartyDetails: true,
                productId: updatePayload.productId
            };
        case NAVIGATE_PRODUCT_MASTER:
            return {
                ...state,
                isPartyDetails: false
            };
        default:
            return state;
    }
};
